<template>
  <div class="white-box position-relative">
    <TileLoader :loading="loading"/>
    <div class="title-container">
      <h2>Commentaire au gestionnaire RFA</h2>
    </div>
    <div class="comment-content" v-if="!loading">
      <div class="filters-container">
        <div class="filters-row">
          <div class="filter-group">
            <label>Année</label>
            <select v-model="selectedYear" @change="loadComment">
              <option v-for="year in availableYears" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
            <label class="checkbox-label">
              <input type="checkbox" v-model="isAdvance" @change="onAdvanceChange"/>
              Acompte
            </label>
          </div>
          <div class="filter-group" v-if="!isAdvance">
            <label>Concept</label>
            <select v-model="selectedConcept" @change="loadComment">
              <option :value="1">CMEM</option>
              <option :value="2">L&L</option>
              <option :value="4">WA</option>
            </select>
          </div>
        </div>
      </div>
      <div class="comment-section">
        <textarea
          v-model="comment"
          placeholder="Saisissez votre commentaire ici..."
          rows="6"
        ></textarea>
        <button class="btn-cmem" @click="saveComment" :disabled="saving || !isDirty">
          {{ saving ? 'Enregistrement...' : 'Enregistrer' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import TileLoader from "../../Dashboards/TileLoader.vue";
import {getCommentFrs, saveCommentFrs} from "@/utils/dashboardCdm";
import dayjs from "dayjs";

export default {
  name: 'FrsCommentTile',
  components: {TileLoader},
  props: ["frsGuid"],
  data() {
    return {
      loading: false,
      saving: false,
      selectedYear: null,
      isAdvance: false,
      selectedConcept: 1,
      comment: "",
      originalComment: "",
      availableYears: []
    }
  },
  mounted() {
    this.initYears();
    this.loadComment();
  },
  methods: {
    initYears() {
      const currentYear = dayjs().year();
      const currentMonth = dayjs().month() + 1; // dayjs months are 0-indexed

      // Si on est avant le 1er mai (mois 5), afficher N-1 par défaut
      const defaultYear = currentMonth < 5 ? currentYear - 1 : currentYear;

      // Générer 3 ans d'historique à partir de l'année actuelle
      this.availableYears = [currentYear, currentYear - 1, currentYear - 2];
      this.selectedYear = defaultYear;
    },
    onAdvanceChange() {
      // Quand on coche Acompte, toujours mettre le concept à 1
      if (this.isAdvance) {
        this.selectedConcept = 1;
      }
      this.loadComment();
    },
    loadComment() {
      if (!this.frsGuid || !this.selectedYear) return;

      this.loading = true;
      const body = {
        FrsGuid: this.frsGuid,
        Year: this.selectedYear,
        IsAdvance: this.isAdvance,
        Concept: this.isAdvance ? 1 : this.selectedConcept
      };

      getCommentFrs(body).then(res => {
        this.comment = res && res.Comment ? res.Comment : "";
        this.originalComment = this.comment;
        this.loading = false;
      }).catch(() => {
        this.comment = "";
        this.originalComment = "";
        this.loading = false;
      });
    },
    saveComment() {
      if (!this.frsGuid || !this.selectedYear) return;

      this.saving = true;
      const body = {
        FrsGuid: this.frsGuid,
        Year: this.selectedYear,
        IsAdvance: this.isAdvance,
        Concept: this.isAdvance ? 1 : this.selectedConcept,
        Comment: this.comment
      };

      saveCommentFrs(body).then(() => {
        this.originalComment = this.comment;
        this.saving = false;
      }).catch(() => {
        this.saving = false;
      });
    }
  },
  computed: {
    isDirty() {
      return this.comment !== this.originalComment;
    }
  },
  watch: {
    frsGuid() {
      this.loadComment();
    }
  }
}
</script>

<style scoped>
.white-box {
  padding: 12px;
  flex: 1 1 30em;
}

.title-container {
  position: relative;
  margin-bottom: 8px;
}

.title-container::after {
  display: block;
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, #FFFFFF 0%, #9F9F9F 100%);
}

.title-container h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.comment-content {
  padding-top: 12px;
}

.filters-container {
  margin-bottom: 16px;
}

.filters-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-group label:not(.checkbox-label) {
  font-size: 14px;
  font-weight: 500;
}

.filter-group select {
  padding: 6px 12px;
  border: 1px solid #9F9F9F;
  border-radius: 4px;
  background: white;
  font-size: 14px;
  min-width: 120px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: normal;
}

.checkbox-label input[type="checkbox"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.comment-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.comment-section textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #9F9F9F;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
}

.comment-section textarea:focus {
  outline: none;
  border-color: #A7C13C;
}

.btn-cmem {
  align-self: flex-start;
  padding: 8px 24px;
  background-color: #A7C13C;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-cmem:hover:not(:disabled) {
  background-color: #95ad35;
}

.btn-cmem:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/RecapPage/FrsCommentTile.vue